import React from 'react';
import { Box, Typography } from '@mui/material';
import { Alert24Regular } from '@fluentui/react-icons';

const NoPermission: React.FC = () => (
  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', bgcolor: 'background.default' }}>
    <Alert24Regular style={{ fontSize: 64, color: '#DC2626', marginBottom: 16 }} />
    <Typography variant="h4" sx={{ mb: 2, color: '#DC2626' }}>
      No Permission
    </Typography>
    <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 400, textAlign: 'center' }}>
      You do not have permission to access this application. Please contact your super user to get the right permissions.
    </Typography>
  </Box>
);

export default NoPermission; 